import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Calendar = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Calendar' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,5 L22,5 L22,22 L2,22 L2,5 Z M18,5 L18,1 M6,5 L6,1 M2,10 L22,10' />
  </StyledIcon>
);
